module.exports = {"data":[{"title":"Leftover Meal Plan Swipes: No Waste Here","date":"2016-8-7","where":"The New York Times","link":"http://www.nytimes.com/2016/08/07/education/edlife/what-to-do-with-those-leftover-meal-plan-swipes.html"},{"title":"What to Know about the Cost of Paying for Meals in College","date":"2018-5-23","where":"US News and World Report","link":"https://www.usnews.com/education/best-colleges/paying-for-college/articles/2018-05-23/what-to-know-about-the-cost-of-paying-for-meals-in-college"}]}


//////////////////
// WEBPACK FOOTER
// ./src/pages/press/press.json
// module id = 544
// module chunks = 44341822457911